
export const uploadFile = (data, onUploadProgress) => ({
  method: 'POST',
  url: '/nfiles',
  data,
  onUploadProgress
});
export const fileTextract = data => ({
  method: 'POST',
  url: '/documents/textract',
  data
});
export const getContractFiles = contractId => ({
  method: 'GET',
  url: `/nfiles/contract/${contractId}`
});



export const uploadFileV2 = (file, onUploadProgress = () => {}, headers = {}, body = {}) => {
  const data = new FormData()
  data.append('file', file);
  Object.entries(body).forEach(([key, value])=> data.append(key, value))
  return {
    url: '/uploads',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...headers
    },
    onUploadProgress: (evt) => onUploadProgress(evt, body)
  }
}

export const detectText = data => ({
  method: 'POST',
  url: '/documents/detect-text',
  data
});

export const extractINEData = data => ({
  method: 'POST',
  url: '/documents/ine/extract',
  data
});